
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 21","stroke-opacity":"0","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 14.75a.75.75 0 000 1.5v-1.5zm-10 1.5a.75.75 0 000-1.5v1.5zM15 7.5v.75a.75.75 0 00.75-.75H15zm-10 0h-.75c0 .414.336.75.75.75V7.5zm-2 .75h14v-1.5H3v1.5zM18.25 9.5v4h1.5v-4h-1.5zm-16.5 4v-4H.25v4h1.5zM17 14.75h-2v1.5h2v-1.5zm-12 0H3v1.5h2v-1.5zM.25 13.5A2.75 2.75 0 003 16.25v-1.5c-.69 0-1.25-.56-1.25-1.25H.25zm18 0c0 .69-.56 1.25-1.25 1.25v1.5a2.75 2.75 0 002.75-2.75h-1.5zM17 8.25c.69 0 1.25.56 1.25 1.25h1.5A2.75 2.75 0 0017 6.75v1.5zM3 6.75A2.75 2.75 0 00.25 9.5h1.5c0-.69.56-1.25 1.25-1.25v-1.5zm4 5.5h6v-1.5H7v1.5zm7.25 1.25v4h1.5v-4h-1.5zM13 18.75H7v1.5h6v-1.5zM5.75 17.5v-4h-1.5v4h1.5zM7 18.75c-.69 0-1.25-.56-1.25-1.25h-1.5A2.75 2.75 0 007 20.25v-1.5zm7.25-1.25c0 .69-.56 1.25-1.25 1.25v1.5a2.75 2.75 0 002.75-2.75h-1.5zM13 12.25c.69 0 1.25.56 1.25 1.25h1.5A2.75 2.75 0 0013 10.75v1.5zm-6-1.5a2.75 2.75 0 00-2.75 2.75h1.5c0-.69.56-1.25 1.25-1.25v-1.5zm0-8.5h6V.75H7v1.5zm7.25 1.25v4h1.5v-4h-1.5zM15 6.75H5v1.5h10v-1.5zm-9.25.75v-4h-1.5v4h1.5zM13 2.25c.69 0 1.25.56 1.25 1.25h1.5A2.75 2.75 0 0013 .75v1.5zM7 .75A2.75 2.75 0 004.25 3.5h1.5c0-.69.56-1.25 1.25-1.25V.75z"}})])
          )
        }
      }
    